import $ from 'jquery';

import { FireHelpers } from '@base';

// Filters
import { Filters } from '@component/filters';

// Components
import { PlyrVideo } from '@template/components/plyr-video/plyr-video';
import { Directory } from '@template/components/directory/directory';
import { Cores } from '@template/components/cores/cores';
import { Events } from '@template/components/events/events';
import { ImageGallery } from '@template/components/image-gallery/image-gallery';
import { MediaCarousel } from '@template/components/media-carousel/media-carousel';
import { Search } from '@template/components/search/search';
import { SidebarNav } from '@template/components/main-nav/sidebar-nav';
import { UtilityNav } from '@template/components/main-nav/utility-nav';
import { ContactInfo } from '@template/components/contact-info/contact-info';
import { Paragraph } from '@template/components/paragraph/paragraph';
import { HeroCarousel } from '@template/components/hero-carousel/hero-carousel';

// Content
import { Event } from '@template/content/event/event';

/**
 * @type class
 * @name FireComponentRecord
 * @description
 *
 * Component record class
 *
 **/

export class FireComponentRecord {
  // register correct component
  _registerComponent(component, name, id, afterBehaviorHit) {
    // mark as registered
    $(component).attr('data-registered', id);

    // init correct component class
    switch (name) {
      case 'plyr-video':
        if (!afterBehaviorHit) {
          new PlyrVideo(id).init();
        }
        break;
      case 'directory':
        if (!afterBehaviorHit) {
          new Directory(id).init();
        }
        break;
      case 'cores':
        if (!afterBehaviorHit) {
          new Cores(id).init();
        }
        break;
      case 'events':
        if (!afterBehaviorHit) {
          new Events(id).init();
        }
        break;
      case 'filters':
        if (!afterBehaviorHit) {
          new Filters(id).init();
        }
        break;
      case 'image-gallery':
        if (!afterBehaviorHit) {
          new ImageGallery(id).init();
        }
        break;
      case 'sidebar-nav':
        if (!afterBehaviorHit) {
          new SidebarNav(id).init();
        }
        break;
      case 'utility-nav':
        if (!afterBehaviorHit) {
          new UtilityNav(id).init();
        }
        break;
      case 'search':
        if (!afterBehaviorHit) {
          new Search(id).init();
        }
        break;
      case 'media-carousel':
        if (!afterBehaviorHit) {
          new MediaCarousel(id).init();
        }
        break;
      case 'event':
        if (!afterBehaviorHit) {
          new Event(id).init();
        }
        break;
      case 'contact-info':
        if (!afterBehaviorHit) {
          new ContactInfo(id).init();
        }
        break;
      case 'paragraph':
        if (!afterBehaviorHit) {
          new Paragraph(id).init();
        }
        break;
      case 'hero-carousel':
        if (!afterBehaviorHit) {
          new HeroCarousel(id).init();
        }
        break;
      default:
        break;
    }
  }

  registerAllComponents(afterBehaviorHit) {
    // loop through all components on the page
    $('[data-bux-component]').each((index, component) => {
      // get name of component
      let names = $(component).data('bux-component');
      names = names.split(', ');

      // generate a unique ID
      const id = FireHelpers.generateUniqueId();

      for (const name of names) {
        if (!$(component).attr('data-registered')) {
          this._registerComponent(component, name, id, afterBehaviorHit);
        }
      }
    });
  }
}
